module.exports = __webpack_public_path__ + "static/media/Portfolio.170eb974.png";